import { IntegrationProvider } from "@repo/app-types/entities/integration";
import { KnowledgeBaseSyncProviderLogo } from "@repo/ui/knowledgeBaseSync/knowledgeBaseSyncProviderLogo";
import type { FC, ReactNode } from "react";
import genesysLogoSrc from "../../../assets/integrations/genesysLogo.svg";
import s3LogoSrc from "../../../assets/integrations/s3Logo.svg";
import slackLogoSrc from "../../../assets/integrations/slackLogo.png";
import teamsLogoSrc from "../../../assets/integrations/teamsLogo.png";
import zoomLogoSrc from "../../../assets/integrations/zoomLogo.svg";

/**
 * An integration provider's logo in a small bordered chip. Shared by the
 * integrations overview table, the shared detail header, and the Genesys detail
 * header, so the chip's size and framing stay identical everywhere it appears.
 * Renders nothing for a provider without a logo.
 */
export const IntegrationLogo: FC<{ provider: IntegrationProvider }> = ({
  provider,
}) => {
  let logo: ReactNode;
  switch (provider) {
    case IntegrationProvider.SLACK:
      logo = (
        <img
          src={slackLogoSrc}
          alt=""
          aria-hidden="true"
          className="size-4 object-contain"
        />
      );
      break;
    case IntegrationProvider.TEAMS:
      logo = (
        <img
          src={teamsLogoSrc}
          alt=""
          aria-hidden="true"
          className="size-4 object-contain"
        />
      );
      break;
    case IntegrationProvider.GURU:
    case IntegrationProvider.KUSTOMER:
      logo = (
        <KnowledgeBaseSyncProviderLogo provider={provider} className="size-4" />
      );
      break;
    case IntegrationProvider.GENESYS:
      logo = (
        <img
          src={genesysLogoSrc}
          alt=""
          aria-hidden="true"
          className="size-4 object-contain"
        />
      );
      break;
    case IntegrationProvider.ZOOM_CONTACT_CENTER:
      logo = (
        <img
          src={zoomLogoSrc}
          alt=""
          aria-hidden="true"
          className="size-4 object-contain"
        />
      );
      break;
    case IntegrationProvider.RECORDING_S3_INTAKE:
      logo = (
        <img
          src={s3LogoSrc}
          alt=""
          aria-hidden="true"
          className="size-4 object-contain"
        />
      );
      break;
    default:
      return null;
  }

  return (
    <span className="flex size-6 shrink-0 items-center justify-center rounded-sm border border-border-light bg-card">
      {logo}
    </span>
  );
};
